var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInkEraserActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#1A202C",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M679.23-240h188.46v60H619.23l60-60Zm-493.08 60-70.76-70.77Q94.31-271.85 93.81-302t20.58-52.23l423.07-439.08q21.08-22.07 50.92-21.88 29.85.19 50.93 21.27l181.3 181.31q21.08 21.07 21.27 51.42.19 30.34-20.88 51.42L499.23-180H186.15Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInkEraserActive);
export default __webpack_public_path__ + "static/media/InkEraserActive.356967921f48cace18981d94f12db469.svg";
export { ForwardRef as ReactComponent };